var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTellIconBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 24C17.1046 24 18 23.1046 18 22C18 20.8954 17.1046 20 16 20C14.8954 20 14 20.8954 14 22C14 23.1046 14.8954 24 16 24Z",
    fill: "#04B7EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 22C24 23.1046 23.1046 24 22 24C20.8954 24 20 23.1046 20 22C20 20.8954 20.8954 20 22 20C23.1046 20 24 20.8954 24 22Z",
    fill: "#04B7EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 24C29.1046 24 30 23.1046 30 22C30 20.8954 29.1046 20 28 20C26.8954 20 26 20.8954 26 22C26 23.1046 26.8954 24 28 24Z",
    fill: "#04B7EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 41L6.10143 31.0647C4.46395 28.2977 3.52478 25.0731 3.52478 21.6304C3.52478 11.3411 11.9139 3 22.2624 3C32.6109 3 41 11.3411 41 21.6304C41 31.9197 32.6109 40.2609 22.2624 40.2609C18.759 40.2609 15.4803 39.3049 12.6755 37.641L3 41ZM7.82262 30.0462L8.27562 30.8116L6.09105 37.8098L12.8971 35.447L13.6959 35.9209C16.1999 37.4064 19.1274 38.2609 22.2624 38.2609C31.5171 38.2609 39 30.8044 39 21.6304C39 12.4565 31.5171 5 22.2624 5C13.0076 5 5.52478 12.4565 5.52478 21.6304C5.52478 24.7045 6.36238 27.5786 7.82262 30.0462Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTellIconBig);
export default __webpack_public_path__ + "static/media/TellIconBig.080221efd00f9416d2628281878b4ef6.svg";
export { ForwardRef as ReactComponent };